<template>
  <div class="carousel">
    <el-row class="hidden-md-and-down">
      <el-col :sm="24">
        <el-carousel :interval="5000" height="330px" trigger="click">
          <el-carousel-item v-for="item in 4" :key="item">
            <!-- <div class="container"> -->
            <img
              src="../../assets/img-banner@2x.jpg"
              style="width: 100%; height: 100%"
              alt=""
            />
            <!-- </div> -->
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
  </div>
</template>

<style>
.carousel {
  /* margin-bottom: 2rem; */
}

.carousel .el-carousel__arrow {
  background-color: #fff !important;
  color: black !important;
}

.carousel .el-carousel__arrow.el-carousel__arrow--left {
  left: 230px;
}

.carousel .el-carousel__arrow.el-carousel__arrow--right {
  right: 200px;
}
</style>